module.exports = __webpack_public_path__ + "static/media/abf.01d050a8.png";